// append this list when you add a new device
export enum DEVICES {
    PC303 = 'PC303',
    PM6100 = 'PM6100',
    F4 = 'F4', // connected weight scale
    SCHILLER_ECG = 'ECGSchiller',
    THERMO_TAIDOC = 'TAIDOC TD1242',
    TAIDOC_BGMETER = 'TAIDOC BGMETER',
    WELCH_ALLYN_CONNEX_SPOT_MONITOR = 'Connex Spot Monitor',
    ECG_WATCH_FOLDER = 'ECG_WATCH_FOLDER',
    PM6100_BLE = 'PM6100_BLE',
    SE_1515 = 'SE-1515',
    TOUCH_ECG = 'TOUCH_ECG',
    IM3S = 'IM3S',
    IM3S_BLE = 'IM3S_BLE',
    MIR_SPIROMETRY = 'MIR_SPIROMETRY'
}

export enum DEVICE_TYPE {
    SERIAL = 'serial',
    BLE = 'ble',
}

export type MedconnectDeviceValue = {
    name: DEVICES
    type: DEVICE_TYPE
    port?: string
    baudrate?: 9600 | 115200
    receiver_name?: string
    sender_name?: string
    gdt_folder_path?: string
    ecg_folder_path?: string;
    filePrefix?: string;
    fileSuffix?: string;
    mir_protocol?: string;
    mir_software_type?: string;
    mir_exchange_folder?: string;
    mir_exchange_folder_exchange?: string;
    mir_program_path?: string;
    ecg_program_path?: string;
    ble_name?: string;
}

export type MedconnectDevice = MedconnectDeviceValue & {
    _id: string
}

export type MedconnectDevicesConfig = {
    SUPPORT_NAME: string
    INSTALLER_NAME: string
    Devices: MedconnectDevice[]
}

export const DEVICE_IMG = {
    "PC303": "https://cdn.dotmed.com/images/listingpics2/3/6/1/3/3613120.jpg",
    "PM6100": "https://redmine.technolda.com/attachments/download/1302/Berry-PM6100-FrontFace.png",
    "F4": "https://cdn.shopify.com/s/files/1/0581/4727/4936/products/F4_4a7af6ae-c6ab-419b-bb0c-ce8e7e900a87_1024x.gif?v=1648026862",
    "ECGSchiller": "https://www.cardiodepot.fr/images/188/p/188_318785_max.jpg",
    "TAIDOC TD1242": "https://taidoc.com/wp-content/uploads/2020/07/TD-1242-URIGHT-500x500-1.jpg",
    "TAIDOC BGMETER": "https://img.medicalexpo.fr/images_me/photo-g/70247-14816183.webp",
    "Connex Spot Monitor": "https://assets.hillrom.com/is/image/hillrom/pdp-CSM_Pro6000-Masimo_SpO2-wScreen_Front_facing-RRp-DE-EMEA-1-1?$pdpImage$",
    "ECG_WATCH_FOLDER": "https://static-00.iconduck.com/assets.00/folder-view-icon-2048x1951-r75ji47l.png",
    "PM6100_BLE": "https://redmine.technolda.com/attachments/download/1302/Berry-PM6100-FrontFace.png",
    "SE-1515": "https://www.pelegrinamedical.com/resize/Shared/Images/Product/EDAN-SE-1515-DP-12-PC-Based-ECG-Unit/EDAN-SE-1515-DP-12-PC-Based-ECG-Unit.webp?bw=1000&w=1000&bh=1000&h=1000",
    "TOUCH_ECG": "https://www.cardiolab.fr/wp-content/uploads/ecg-numerique-cardioline-touchecg-dh.jpg",
    "IM3S": "https://www.edan.com.cn/uploadfiles/2021/03/20210319180000000.png",
    "IM3S_BLE": "https://www.edan.com.cn/uploadfiles/2021/03/20210319180000000.png",
    "MIR_SPIROMETRY": "https://www.spirometry.com/img/mir-spirolab.png"
}